import { strCompareLowerCase, toStringSmartly } from '@common/Common';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { ResourceEditorFormSubmitEventPayload, ResourceEditorViewModel } from '@Quest/Resources/Components/ResourceEditor';
import ResourceEditor from '@Quest/Resources/Components/ResourceEditor.vue';
import { CreateResourceCommandV1, DeleteResourceCommandV1, UpdateResourceCommandV1 } from '@Quest/Resources/Domain/commands-core';
import ResourcesCommands from '@Quest/Resources/Domain/commands-vue-component';
import ResourcesQueries from '@Quest/Resources/Domain/queries-vue-component';
import { ResourceReadModel, ResourcesReadModel } from '@Quest/Resources/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({
    components: { CorporateNavigation, ResourceEditor }
})
export default class ResourcesPage extends mixins(ResourcesQueries, ResourcesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: ResourcesReadModel | null = null;
    resourceEditor: ResourceEditorViewModel = new ResourceEditorViewModel();

    get resourcesView(): ResourceReadModel[] { return this.rm.Resources.sort((a, b) => strCompareLowerCase(a.Name, b.Name)); }

    fmtNum(val: number | null) { return toStringSmartly(val); }


    showResourceCreator()
    {
        this.resourceEditor.showCreator();
    }

    showResourceEditor(r: ResourceReadModel)
    {
        this.resourceEditor.showEditor(r.Id, r.Name, r.Unit, r.ExpenseClassification);
    }

    handleResourceEditorFormSubmit(e: ResourceEditorFormSubmitEventPayload)
    {
        if (e.id == null)
        {
            this.invokeCreateResourceCommandV1(this.workspaceId, this.strategyId, guid(), e.name, e.unit, e.classification, e.costPerUnit);
        }
        else
        {
            this.invokeUpdateResourceCommandV1(this.workspaceId, this.strategyId, e.id, e.name, e.unit, e.classification);
        }
    }

    handleDeleteResourceCommand(r: ResourceReadModel)
    {
        if (confirm("Are you sure?") == true)
        {
            this.invokeDeleteResourceCommandV1(this.workspaceId, this.strategyId, r.Id);
        }
    }

    mounted()
    {
        document.title = "Resources | TransparentChoice";
        this.runResourcesByStrategyIdQueryV1(this.workspaceId, this.strategyId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ResourcesReadModel")
        {
            this.rm = model as ResourcesReadModel;
            this.resourceEditor.close();
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateResourceCommandV1.matchType(cmd))
        {
            this.runResourcesByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
        if (DeleteResourceCommandV1.matchType(cmd))
        {
            this.runResourcesByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
        else if (UpdateResourceCommandV1.matchType(cmd))
        {
            this.runResourcesByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
    }
}